export enum ThemeColor {
  Base = 'Base',
  Essential = 'Essential',
  Brand = 'Brand',
  System = 'System',
  Error = 'Error',
  Warning = 'Warning',
  Success = 'Success',
  Info = 'Info',
}

export const themeColors = Object.values(ThemeColor)
